import { Box, Space, Stack, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modal';

import { useRestartDevice } from './use-restart-device';

export const RestartDeviceModal: FC = memo(() => {
  const { handleConfirm, handleClose, isPending, open } = useRestartDevice();

  return (
    <Modal
      opened={open}
      onClose={handleClose}
      centered
      size="lg"
      title=""
      closeOnClickOutside={!isPending}
      closeOnEscape={!isPending}
      withCloseButton={!isPending}
    >
      <Stack gap="md" align="center">
        <Text size="md" c="var(--color-white-placeholder)" ta="center">
          Are you sure you want to restart this device?
        </Text>

        <Text size="sm" c="var(--color-white-placeholder)" ta="center">
          The device will be restarted and may be temporarily unavailable.
        </Text>

        <Space h="lg" />

        <Box display="flex" style={{ gap: '36px' }}>
          <Button
            variant="outline"
            round
            size="md"
            onClick={handleClose}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            variant="filled"
            round
            size="md"
            onClick={handleConfirm}
            loading={isPending}
            disabled={isPending}
          >
            Restart
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
});

RestartDeviceModal.displayName = 'RestartDeviceModal';
